export default __webpack_public_path__ + "static/media/grayStar.45cf0573.svg";